// extracted by mini-css-extract-plugin
module.exports = {"title":"z8O14BCQ","noTitle":"_2MH2esxP","article":"_2OjjNXrh"};